export function stopPropagation(event: React.SyntheticEvent): void {
  event.stopPropagation();
}

export function scrollIntoView(element: Element | null): void {
  element?.scrollIntoView({
    inline: 'nearest',
    block: 'nearest',
    //  behavior: 'smooth'
  });
}

// Modals opened from grid flows live in floating-ui portals outside the grid
// (and outside the cell's React tree). Focus or clicks landing there are not
// "leaving" the grid — the dialog returns focus when it closes.
export function isInFloatingLayer(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest('[data-floating-ui-portal], [role="dialog"]') !== null;
}

export function getCellToScroll(gridEl: HTMLDivElement): HTMLDivElement | null {
  return gridEl.querySelector<HTMLDivElement>(':scope > [role="row"] > [tabindex="0"]');
}

export function focusCellOrCellContent(gridEl: HTMLDivElement): void {
  const cell = getCellToScroll(gridEl);
  if (cell === null) return;

  scrollIntoView(cell);
  // Focus cell content when available instead of the cell itself
  const elementToFocus = cell.querySelector<Element & HTMLOrSVGElement>('[tabindex="0"]') ?? cell;
  // Works around modal dismissial refocus
  setTimeout(() => {
    elementToFocus.focus({ preventScroll: true });
  });
}
